import { ClipboardCheck, Headphones, MapPinned, PackageCheck, Route, Truck } from "lucide-react";

const strengths = [
  {
    icon: Route,
    title: "Jaringan Mitra",
    desc: "Mendukung kebutuhan pelanggan dari Mojokerto ke berbagai wilayah Indonesia.",
  },
  {
    icon: Headphones,
    title: "Tim Sales Responsif",
    desc: "Konsultasi produk, ketersediaan, dan penawaran dapat dibantu langsung oleh tim kami.",
  },
  {
    icon: ClipboardCheck,
    title: "Kebutuhan Proyek",
    desc: "Kami terbiasa menyesuaikan rekomendasi produk dengan aplikasi dan skala kebutuhan.",
  },
  {
    icon: PackageCheck,
    title: "Pasokan Bertahap",
    desc: "Lini produk dapat terus dikembangkan mengikuti permintaan pasar dan kebutuhan pelanggan.",
  },
  {
    icon: Truck,
    title: "Pengiriman Nasional",
    desc: "Dukungan pengiriman untuk pelanggan retail, kontraktor, dan kebutuhan proyek.",
  },
  {
    icon: MapPinned,
    title: "Berbasis di Jawa Timur",
    desc: "Lokasi operasional di Mojokerto membantu kami menjangkau pasar regional dan nasional.",
  },
];

export const CorporateStrengths = () => {
  return (
    <section id="keunggulan" data-testid="corporate-strengths-section" className="py-24 lg:py-32 bg-animax-gray">
      <div className="max-w-7xl mx-auto px-5 sm:px-6">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="tag-uppercase text-animax-orange mb-4">Kenapa Memilih Kami</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-animax-black">
              Partner yang siap mendukung kebutuhan material Anda
            </h2>
            <p className="mt-4 text-neutral-600 text-lg leading-relaxed">
              Fokus kami bukan hanya menjual produk, tetapi membantu pelanggan menemukan material
              yang sesuai dengan kebutuhan aplikasi, lokasi, dan timeline proyek.
            </p>
          </div>

          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {strengths.map((item, index) => (
              <article
                key={item.title}
                data-testid={`corporate-strength-${index}`}
                className="card-lift p-6 rounded-2xl bg-white border border-neutral-200"
              >
                <div className="w-11 h-11 rounded-lg bg-animax-yellow/20 flex items-center justify-center mb-5">
                  <item.icon className="w-5 h-5 text-animax-orange" />
                </div>
                <h3 className="font-display text-lg font-medium text-animax-black">{item.title}</h3>
                <p className="mt-2 text-sm text-neutral-600 leading-relaxed">{item.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
